//zh.js
const zh = {
    mainNavigation: {
        title0:'首页',
        title1: '关于我们',
        title2:'技术与产品',
        title3:'科学研究',
        title4:'新闻中心',
        title5:'联系我们'
    },
    viceNavigation:{
        navtit1:'企业简介',
        navtit2:'创始人介绍',
        navtit3:'专家团队',
        navtit4:'技术创新',
        navtit5:'产品管线',
        navtit6:'公司新闻',
        navtit7:'行业资讯',
        navtit8:'加入我们',
    },
    other:{
        more:'阅读更多',
        link:'文章链接',
        title1:'科学研究',
        name:'成都威斯津生物医药科技有限公司'

    },
    indexCompany:{
        title:'威斯津生物',
        describe:'成都威斯津生物医药科技有限公司成立于2021年7月,由中科院院士魏于全教授与在mRNA药物研发领域深耕10余年的宋相容教授联合创建。公司聚焦于mRNA创新药物和佐剂研发,致力于成为拥有核心技术和自主知识产权,集mRNA药物研发、生产、销售于一体的全球化生物医药公司。'
    },
    indexApply:{
        title:'应用领域',
        describe:'公司产品管线拥有包括抗病毒等预防性疫苗，抗肿瘤、衰老、肥胖疫苗，基因编辑及新型纳米佐剂在内的超20个mRNA药物和疫苗新佐剂品种。'
    },
    indexTechnology:{
        title:'技术创新',
        describe:'威斯津生物依托于四川大学华西医院生物治疗国家重点实验室平台,组建了一支由专家教授组成的核心技术团队,研究范围覆盖了生物学、免疫学、计算机辅助药物设计、化学合成、纳米医学、生物信息学、药理毒理学等领域,通过建立多学科协作创新的模式,在原料mRNA的设计、递送技术及成药转化方面取得了一系列技术突破。'
    },
    indexBottom:{
        describe:'以创新研发为基石,做有核心技术和自主知识产权的国际mRNA生物医药及纳米佐剂研发和制造企业,为人类攻克疾病创造更有效的药物和治疗方案。',
        tag1:'临床阶段产品',
        tag2:'阶段研发产品',
        tag3:'科研人员'
    },
    CompanyIntroduction:{
        text1:'成都威斯津生物医药科技有限公司成立于2021年7月,由中科院院士魏于全教授与曾在哈佛医学院从事mRNA药物相关研究并在该领域深耕近10年的宋相容教授联合创建。公司聚焦于mRNA创新药物和佐剂开发,致力于成为拥有核心技术和自主知识产权,集研发、生产、销售于一体的全球化生物医药公司。',
        text2:'依托四川大学华西医院生物治疗国家重点实验室平台,威斯津生物组织了生物学、药学、免疫学、计算机辅助药物设计、纳米医学、生物信息学、临床医学等领域的专家学者,协同创新,致力于mRNA药物底层技术的研究和突破。',
        text3:'威斯津生物着眼于临床应用,以创新为驱动,构建了“产、学、研、医”协同推进的新药研发和转化模式。团队在mRNA药物研发的三大关键技术：mRNA序列、递送载体以及放大生产上均获得全面突破,并布局了mRNA序列、递送载体和智能制造设备等核心专利,突破了mRNA药物的全球专利壁垒,实现完整的自主知识产权。',
        text4:'以大量科研成果为基础，威斯津生物已搭建起成熟的mRNA药物技术平台和新型纳米佐剂平台，拥有抗病毒等预防性疫苗，抗肿瘤、衰老、肥胖疫苗，基因编辑及新型纳米佐剂在内的超20个产品管线。其中，新型纳米佐剂已获国家批准紧急使用（EUA），3个1类mRNA新药已经进入了临床试验。威斯津管线总体设计以肿瘤治疗性mRNA疫苗为重点,采用短线、中线、长线的差异化布局，实现小步快走。威斯津生物具有强劲的发展势头和极强的抗风险能力，有望近期再次实现跨越式发展。' 
    },
    founderTit:'威斯津生物——创始人',
    womanFounder:{
        name:'宋 相 容',
        tag1:'国家级青年人才',
        tag2:'四川大学研究员/博士生导师',
        tag3:'药剂学博士',
        tag4:'生物学博士后',
        describe1:'成都威斯津生物医药科技有限公司联合创始人、总经理、哈佛医学院纳米医学和免疫学Visiting Professor、四川大学教授/博士生导师，并担任中国医药生物技术协会纳米生物技术分会委员、中国疫苗行业协会核酸疫苗分会委员、国家药品监督管理局仿创药物及药用辅料综合评价重点实验室学术委员会委员、四川省医学传播学会副会长等9项国家及省部级的学会委员及以上职务，以及6个SCI期刊的编委职务，包括：任Sig Transduct Target Ther(IF 38.1)、Asian J Pharm Sci(IF 9.3)、Eur J Pharm Sci(IF 5.1)、Nat Rev Drug Discov(IF=64.797)等编委 ，Acta Pharm Sin B(IF 14.9)及Chin Chem Lett(IF 8.5)的青年编委。入选国家级青年人才、四川省天府万人计划天府科技菁英、四川省卫生健康委学术技术带头人、四川省学术和技术带头人后备人选。',
        describe2:'宋相容博士长期从事基于靶向递送的创新药物研发，拥有20余年的新药研发经验，已全面突破mRNA药物研发的关键底层技术，布局了mRNA序列、递送载体和智能制造设备等核心专利。申请专利60余项(国际专利5项)，已授权20余项；主持国家科技重大专项、国家自然科学基金等国家及省部级等课题30余项，在Nature、Nat Comm、Sci Adv等发表SCI论文100余篇(一作/通讯IF>10的20余篇)。牵头研发的3个1类mRNA新药已经进入了临床试验、新型纳米佐剂已获得国内EUA许可。<br ><span style="text-indent: 2em;display:inline-block; margin-top: 16px;">相关研究荣获省部级以上重要奖项4项：国家科技部2022年度全国颠覆性技术创新大赛优胜奖（最高奖，排名第1）、首届中国西部巾帼科技创新大赛金奖（排名第1，2023）、中国民族医药学会科学技术奖一等奖（排名第3，2019）、中华医学科技奖三等奖（排名第6，2020）。宋相容博士在新药转化研发方面积累了较为丰富的实战经验。</span>'

    },
    manFounder:{
        name:'魏 于 全 ',
        tag1:'中国科学院院士',
        tag2:'四川大学教授/博士生导师',
        describe1:'成都威斯津生物医药科技有限公司联合创始人、董事长、四川大学教授/博士生导师；并担任华西医院临床肿瘤中心主任与生物治疗国家重点实验室主任、中国医药生物技术协会理事长、国家生物治疗协同创新中心负责人职务。魏于全教授还曾经担任四川大学副校长、中华医学会副会长、教育部科学技术委员会生物医学部常务副主任等职，也是Signal Transduction and Targeted Therapy共同主编，Human Gene Therapy副主编，Current Molecular Medicine副主编。',
        describe2:'魏于全教授长期从事肿瘤生物治疗的基础研究、应用开发和临床医疗，对肿瘤生物治疗做出了重要贡献。在肿瘤微环境中的间质细胞，包括免疫细胞、纤维母细胞和血管内皮细胞等对肿瘤生长的影响，以及肿瘤细胞的代谢产物对免疫细胞的调节作用等领域，魏教授有着极其深入的研究。在基因药物与疫苗等生物药以及小分子靶向药物等的基础研发与转化应用等方面，魏于全教授取得了一系列创新性的研究成果，并在产学研合作与成果转让方面成绩突出，由他带领团队研发的生物药以及小分子靶向药物等具有自主知识产权的专利产品，已成功实现转化，国内多家药厂获得其授权，并处于联合开发阶段。魏于全院士带领团队建立了国际先进的昆虫细胞生产重组蛋白疫苗技术平台，研发出的针对XBB等新冠病毒变异毒株的2款蛋白疫苗，经国家相关部门批准均已纳入紧急使用（EUA）。'
    },
    technologicalList:{
        title:'技术创新',
        describe1:'聚焦底层关键技术攻关,<br />威斯津生物在mRNA药物技术领域<br />获得多项专利',
        describe2:'发生于2019年年底的新冠疫情,极大地推动了mRNA疫苗这一新兴药物全面进入市场,全球知名药企在mRNA新药领域竞相进行专利和产品布局。',
        describe3:'目前,mRNA药物技术主要在序列优化与合成、递送系统及制剂大规模制造与储存方面面临着挑战。具体到mRNA药物的研发,其原料mRNA和递送载体是两大核心技术,直接关系到mRNA药物的有效性、安全性和贮存稳定性。依托四川大学华西医院生物治疗国家重点实验室平台,形成了集生物学、药学、临床医学、免疫学、计算机辅助药物设计、纳米医学、生物信息学等领域专业人才的团队,通过建立多学科协作创新的模式,在原料mRNA的设计、递送技术及成药转化方面取得了一系列技术突破：',
        describe4:'目前,威斯津生物已在mRNA序列和递送系统两大核心技术领域及放大生产方面,布局了多项国内外专利,并拥有完整的自主知识产权。基于已有的核心技术,威斯津生物开发了针对奥密克戎（Omicron）及德尔塔（Delta）等新冠病毒变异株的mRNA疫苗,其安全性和免疫原性均显著优于已上市的新冠mRNA疫苗产品。',
        describe5:'威斯津生物储备了包括肿瘤治疗性疫苗、抗衰老药物、抗肥胖药物、基因编辑治疗罕见病/遗传病、编码抗体的mRNA药物、新型佐剂等20多个产品管线,全方位布局了mRNA技术赛道产品。同时,公司对WGa01等新型佐剂的成功开发,打破了国内近几十年来仅有铝佐剂的限制,该新型佐剂协同疫苗诱导中和抗体的水平比传统铝佐剂高10～100倍。'

    },
    technologyOne:{
        title:'mRNA序列核心元件对所编码蛋白/多肽的表达水平有着重要影响',
        describe:'威斯津生物建立机器深度学习平台,辅助优化核酸序列设计,提高编码蛋白/多肽的表达或提呈。'
    },
    technologyTwo:{
        title:'脂质纳米粒(LNP)的核心辅料可电离脂质(ionizable lipids)显著影响mRNA分布和贮存稳定性' ,
        describe:'威斯津生物通过人工智能指导的辅料结构设计,开发了具有自主知识产权的全新脂质辅料,突破了递送技术专利壁垒。'
    },
    technologyThree:{
        title:'mRNA药物制剂的处方组成显著影响有效性、安全性和贮存稳定性' ,
        describe:'开发配方优化新策略,创新阴离子纳米制剂技术,构建了能够实现多个脏器或多种细胞靶向递送的制剂平台。'
    },
    technologyFour:{
        title:'从基础研究转化为临床药品对创新mRNA药物也是一种挑战' ,
        describe:'威斯津生物建立了一套针对多种mRNA创新药物的有效性和安全性的评价方案,搭建了自主知识产权的通用型智能制造设备,成果突破产业化的技术瓶颈,为mRNA药物的临床转化搭建了良好的技术平台。'
    },
    pipelineMenu:{
        title1:'肿瘤治疗疫苗<br>研发平台',
        title2:'蛋白替代<br>药物平台',
        title3:'基因编辑<br>技术平台',
        title4:'预防疫苗<br>研发平台',
        title5:'新型纳米<br>佐剂平台',
        describe:'公司产品管线拥有包括病毒疫苗,抗肿瘤、衰老、肥胖疫苗,基因编辑及新型佐剂在内的超20个mRNA药物和疫苗佐剂品种。'
    },
    pipelineVaccin1:{
        title:'预防疫苗研发平台——4个管线',
        name1:'呼吸道合胞病毒疫苗',
        name2:'疟疾疫苗',
        name3:'登⾰病毒疫苗',
        name4:'新冠疫苗'
    },
    pipelineName:'产品管线',
    pipelineVaccin2:{
        title:'肿瘤治疗疫苗研发平台——6个管线',
        name1:'WGc-043（EBV疫苗）',
        name2:'WGc-0201（HBV疫苗）',
        name3:'WGc-0301（实体瘤疫苗1）',
        name4:'WGc-0501（实体瘤疫苗2）',
        name5:'WGc-0801（实体瘤疫苗3）',
        name6:'WGc-0901（实体瘤疫苗4） ',
    },
    pipelineVaccin3:{
        title:'基因编辑技术平台——3个管线',
        name1:'肝实质细胞编辑',
        name2:'肺泡细胞编辑',
        name3:'脾细胞编辑',
    },
    pipelineVaccin4:{
        title:'蛋白替代药物平台<br>——4个管线',
        name1:'抗癌抗体',
        name2:'肥胖',
        name3:'非酒精性脂肪肝',
        name4:'抗衰老药物'
    },
    pipelineVaccin5:{
        title:'新型纳米佐剂平台——3个管线',
        name1:'新型佐剂 1',
        name2:'新型佐剂 2',
        name3:'新型佐剂 3',
        progress1:'1、两个疫苗品种获得中国EUA上市,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;其中一个即将完成3期临床正式上市',
        progress2:'2、WHO的PQ认证申请中'
    },
    pipelineProgress:{
        title1:'成药研究',
        title2:'临床前研究',
        title3:'申报',
        title4:'IIT/IND申请/I期临床',
        title5:'II期临床',
        title6:'III期临床',
        title7:'EUA上市',
    },
    coutactList:{
        area:"中国 四川省 ",
        city:"成都 天府国际生物城 ",
        Address:"(双流区凤凰路552号)",
        title2:'电话',
        title3:'邮箱',
        title4:'相关事务联络方式',
        peopleNmae1:'人力资源（职业机会及人才管理',
        tel1:'电话：郭女士  13666164764',
        peopleMail1:"邮件：guoyusheng@westgenepharma.com",
        peopleNmae2:'投资咨询',
        tel2:'电话：张先生 18628152521',
        peopleMail2:"邮件：zhangjinjin@westgenepharma.com",
        peopleNmae3:'商务合作',
        tel3:'电话：杨先生 17311313455',
        peopleMail3:"邮件：yangyang@westgenepharma.com",
    },
    addCompany:{
        tit1:'企业愿景',
        text1:`成为一家受人尊重<br>且创新不竭的企业`,
        tit2:'企业使命',
        text2:`为人类攻克疾病<br>创造更有效的药物和治疗方案`,
        tit3:'核心价值观',
        text3:`秉承科学、专注创新<br>开放合作、坚守质量`
    },
    page:{
        title:"威斯津生物的全球首款EB病毒相关肿瘤mRNA治疗性疫苗，获国家批准开展临床试验",
        time:'2024年8月6日',
        text1:'成都威斯津生物医药科技有限公司（威斯津生物）自主研发的"WGc-043注射液"，其新药研究申请（IND）获得中国国家药品监督管理局（NMPA）药品审评中心（CDE）批准，收到国家药监局核准签发的《药物临床试验批准通知书》，可以开展I期临床试验。"WGc-043注射液"是全球首个中美双报均获批IND的治疗EB病毒相关肿瘤的mRNA疫苗。',
        text2:'mRNA肿瘤治疗性疫苗是目前mRNA创新药领域和肿瘤免疫疗法的重大突破口之一。默沙东（MSD）、莫德纳（Moderna）、拜恩泰克(BioNTech)等国际知名制药企业，在该领域均有密集布局，研发进展不一。威斯津生物的肿瘤治疗性疫苗管线"WGc-043注射液"此次获批IND，进一步验证了其在递送载体、序列设计等mRNA核心技术上的成熟性，也加速了全球高效低毒的抗肿瘤mRNA疫苗的商业化进程。',
        title1:'EB病毒相关肿瘤患者，可以选择的全新免疫治疗方案',
        text3:'WGc-043 mRNA疫苗已于今年5月在美国获批IND，中美批准的适应症均为EB病毒阳性肿瘤：一是适用于经过二线系统治疗的EB病毒阳性晚期实体瘤成人患者；二是适用于复发或难治性的EB病毒阳性血液瘤成人患者。WGc-043，可为终末期EB病毒阳性实体瘤和血液瘤患者提供全新的mRNA免疫治疗方案选择。"接下来，我们将在国内开展临床试验，推动WGc-043 mRNA疫苗尽早商业化使用。"威斯津生物联合创始人兼总经理宋相容教授介绍说，鉴于有前期高质量试验数据的支持，WGc-043 mRNA疫苗有信心在临床试验中，表现出优秀的安全性和抗肿瘤活性。',
        title2:'颠覆性技术压舱，WGc-043 mRNA疫苗技术在先进性和突破性上亮点显著',
        text4:'WGc-043是威斯津生物在mRNA疫苗领域布局的20余个研发管线之一。该项目及其平台技术，在科技部主办的"2022年全国颠覆性技术创新大赛总决赛"中获得最高奖项（优胜奖），被认为具有"革命性、颠覆性"的创新和突破，是"可改变游戏规则"的创新性技术，一举突破了mRNA领域的全球专利封锁和技术壁垒。该项目技术的先进性和突破性体现在以下两方面：',
        text5:'1）通过人工智能实现高效能抗原筛选，优选出最为广谱安全的蛋白序列，mRNA分子中引入了全球原创设计的免疫增强子（IE），该设计使得WGc-043可充分激活患者自体的抗肿瘤免疫，在体内生成杀伤肿瘤的细胞毒性T细胞（cytotoxic T cells，CTLs）、抗原特异性抗体以及记忆性T细胞，具有相当于联合抗癌CAR-T和单克隆抗体的高效抗癌效果，还可避免肿瘤复发。',
        text6:'2）WGc-043的递送载体为全新自主研发，目前已在中国、美国、欧洲、加拿大、澳大利亚和南非等获得专利授权。全新的LNP递送系统的安全性和递送效率，已在威斯津自研的3个品种的临床试验中，得到了充分的验证。',
        title3:'市场潜力巨大，两类肿瘤有望实现mRNA免疫疗法"0"的突破',
        text7:'EB病毒被国际癌症研究机构（IARC）确定为第一类致癌物，在全球人群中的感染率超过90%，是首个被发现的人类致瘤病毒。EB病毒与10多种恶性肿瘤如鼻咽癌、淋巴瘤、胃癌、肺癌、肝癌、食管癌、乳腺癌、宫颈癌等高度相关，WGc-043获批适应症患者为EB病毒阳性的实体瘤和血液瘤成人患者，其定位市场的潜力巨大。WGc-043已完成了针对鼻咽癌和自然杀伤T细胞淋巴瘤两个适应症的IIT（研究者发起的临床试验），展现出比现有公开的其它mRNA肿瘤治疗性疫苗更优越的安全性和有效性。可以预见，一旦WGc-043成功上市，将在EB病毒阳性的实体瘤和血液瘤这两类肿瘤中，实现mRNA免疫疗法"0"的突破。',
        title4:'关于威斯津生物：专注于mRNA技术研究及创新药研发',
        text8:'成都威斯津生物医药科技有限公司由中科院院士魏于全教授与曾在哈佛医学院从事mRNA药物相关研究并在该领域深耕近10年的宋相容教授联合创建。公司聚焦于mRNA创新药物和佐剂开发，致力于成为拥有核心技术和自主知识产权，集研发、生产、销售于一体的全球化生物医药公司。',
        text9:'威斯津生物以创新为驱动，在mRNA药物研发的三大关键技术：mRNA序列、递送载体以及放大生产上均获得全面突破，并布局了mRNA序列、递送载体和智能制造设备等核心专利，突破了mRNA药物的全球专利壁垒，实现完整的自主知识产权。',
        title5:'布局20余条mRNA研发管线，商业化进展顺利',
        text10:'在前期科研成果的基础上，威斯津生物已搭建起5大研发平台：肿瘤治疗性疫苗平台、蛋白质替代治疗平台、基因编辑治疗遗传病和罕见病平台、预防性疫苗平台以及新型纳米佐剂平台，形成"产、学、研、医、检"协同推进的新药研发和转化模式。威斯津正在积极推进多方位的对外合作以实现公司未来的商业化布局。',
        text11:'目前，威斯津生物在mRNA药物和纳米佐剂领域布局的产品管线超过20个，全面覆盖了mRNA肿瘤治疗性疫苗、针对传染病的mRNA预防性疫苗，以及针对其他疾病如肥胖、衰老的的治疗性药物等领域。除肿瘤产品获得IND外，新型纳米佐剂WGa01也于去年获得中国紧急使用授权（EUA）并成功上市应用于临床，同时实现了国产"0"生产的重大突破。',


        
    } ,
    page2:{
        title:'威斯津生物应邀赴波士顿解读mRNA"中国范式"',
        time:'2024-8-01',
        text1:'全球首款EB病毒相关肿瘤mRNA治疗性疫苗在中美连续达成IND里程碑',
        text2:'2024年7月29日至31日，全球mRNA行业最重要的学术会议之一——"第四届mRNA疗法峰会"在美国波士顿如期举办。400多名来自世界各地的行业资深人士，以及65位mRNA研发领域的知名专家齐聚波士顿，就mRNA领域的新突破与应用领域的拓展进行了深入的探讨和交流。成都威斯津生物医药科技有限公司联合创始人宋相容教授应邀参会。作为全球首款获批IND的EB病毒相关肿瘤mRNA治疗性疫苗（WGc-043注射液）的研发团队学术带头人，宋相容教授在会上分享了WGc-043的最新研究数据和技术突破，并向与会专家学者详细解读了威斯津生物在mRNA领域"深耕底层技术——产学研医协同推动——完善研发平台——推进创新成果转化"的"中国范式"。',
        text3:'这不是威斯津生物WGc-043项目第一次在重要的国际舞台上亮相。',
        text4:'今年1月，WGc-043因为其出色的临床表现在德国柏林"第三届mRNA疗法峰会"上获得广泛关注；随后，在3月份召开的"第5届疫苗创新国际论坛（VIF）"上，WGc-043又以其技术路线和研究成果受到好评；5月，WGc-043连续在美国获批IND、在中国受理IND，更是在业内引发热评，让威斯津生物跻身全球mRNA疫苗研发的先行者之列。',
        text5:'mRNA技术在癌症、罕见病和传染病领域的应用是当下mRNA领域热点，也是突破点之一。就在本届峰会举办前不久，美国食品药品管理局（FDA）批准上市了一款mRNA呼吸道合胞病毒（RSV）疫苗——mRESVIA（mRNA-1345）。业内普遍认为，应用于癌症、心脑血管疾病和遗传疾病的mRNA新药，也将陆续获得突破。',
        text6:'威斯津生物的WGc-043就是其中的领跑者。',
        text7:'WGc-043诞生于威斯津生物肿瘤治疗性疫苗平台，获批的两个适应症为实体瘤和淋巴瘤。在技术路线上，WGc-043全面运用了威斯津生物在mRNA底层研发上获得的突破性技术，包括在递送载体、序列设计以及放大化生产方面的最新研发成果。这使得其在安全性和有效性两方面的表现都稳定且出色。最新的数据显示，WGc-043项目在肿瘤末线病人上开展的IIT表现出了非常好的安全性，未见三级及以上毒性。对终末期鼻咽癌（NPC）和NK/T细胞淋巴瘤（NKTL）患者而言，WGc-043的重大意义在于，一旦上市，就能终结这两类恶性肿瘤的终末期患者无药可用的现状。',
        text8:'会议期间，宋相容教授还应邀介绍了威斯津生物在mRNA创新药研发上的推动策略。',
        text9:'在她看来，mRNA行业面临的最大挑战在于mRNA的蛋白表达量以及递送系统的效率，需要进一步提高有效性和安全性，同时降低生产成本。而当下最常见的一个误解认为：只要能获得一个新的脂质分子，能较为高效地实现蛋白翻译就可以成功研发新药，忽视了新辅料面临的安全性问题，进而导致药品研发夭折。有鉴于此，威斯津生物自研发之初就确立了底层突破有效性和安全性的逻辑，最终实现了底层关键技术的突破，并获得多项国际专利，搭建起5大研发平台，布局了20余个产品管线。',
        text10:'始终坚持创新推动，产、学、研、医、检协同前行，威斯津生物倡导的"深耕底层技术——产学研医协同推动——完善研发平台——推进创新成果转化"模式，稳健中透着积极，被与会人士评价为mRNA领域的"中国范式"。',
        text11:'29日至31日的全球mRNA疗法峰会，还全面讨论了mRNA药物的最新临床数据、平台开发、监管洞察等多个方面的议题，并就罕见病、肿瘤、个性化医疗、基因编辑和细胞治疗等前沿应用领域进行了深入交流。',
        text12:'宋相容教授表示，能在这样一个重要的平台上展示威斯津生物的研发成果很有意义，"mRNA技术为治疗恶性肿瘤提供了新的希望和新的选择，我们的研究彰显了这一疗法在安全性和有效性方面的巨大潜力。"',
        tage1:'成都威斯津生物',
        tage2:'成都威斯津生物医药科技有限公司联合创始人、总经理宋相容教授'

    }


}
export default zh;



// WEBPACK FOOTER //
// ./src/i18n/config/zh.js